/**
 * Une facture d'acompte que le client n'a pas encore payée.
 *
 * <p>Elle naît à l'acceptation de l'offre, mais ne se range dans « Factures »
 * qu'une fois l'acompte payé (en tout ou en partie) : avant, c'est un acompte
 * attendu, qui se suit depuis l'offre. Annulée, elle n'y paraît jamais.
 *
 * <p>Seul l'acompte de l'offre est concerné : la facture d'avancement
 * (« Situation des travaux à 60 % ») porte aussi le type « acompte », mais le
 * patron la prépare et l'envoie lui-même ; cachée, elle restait introuvable
 * jusqu'à son paiement. L'offre garde le numéro de sa facture d'acompte
 * (`acompteFacture`) : c'est elle seule qui attend.
 *
 * @param {object} f facture
 * @param {object[]} [devis] offres de la société ; sans elles, tout acompte non payé
 * @returns {boolean} vrai pour un acompte d'offre pas encore payé
 */
export function acompteEnAttente(f, devis) {
  if (f?.type !== 'acompte' || f.statut === 'Payée' || f.statut === 'Partielle') return false;
  if (!Array.isArray(devis)) return true;
  const num = String(f.num || '');
  const offre = devis.find((d) => d.id === f.devisId);
  return !!offre && num !== '' && String(offre.acompteFacture || '') === num;
}
